import React from 'react';
import { Checkbox, FormControlLabel } from '@material-ui/core';
import { FieldProps } from 'formik';

interface IProps extends FieldProps {
  placeholder: string;
  label: string;
  disabled?: boolean;
}

export const JwlCheckbox: React.FC<IProps> = ({ label, field, disabled }) => {
  return (
    <label>
      {label}
      <Checkbox size="small" {...field} checked={field.value} disabled={disabled} color="primary"></Checkbox>
    </label>
  );
};
